import * as React from 'react'

// True once React has finished hydrating on the client, false during the
// server render and the hydration pass.
//
// This replaces the `useState(false)` + `useEffect(() => setMounted(true), [])`
// idiom that react-hooks/set-state-in-effect flags. The rule is right about it:
// that shape renders a value already known to be wrong, then schedules an
// effect purely to correct it.
//
// useSyncExternalStore states the same thing declaratively. React reads
// getServerSnapshot() for the server output and the hydration render, then
// switches to getSnapshot() once hydration commits — the same moment the
// effect used to fire, so the visible behaviour is unchanged.
//
// `subscribe` never signals a change because there is nothing to watch: the
// value flips exactly once, and React performs that flip itself when it moves
// off the hydration snapshot. It still returns an unsubscribe function because
// useSyncExternalStore requires one.
const subscribe = () => () => {}
const getSnapshot = () => true
const getServerSnapshot = () => false

export function useIsHydrated() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
